module.exports = __webpack_public_path__ + "img/cleaned_shower.988ebf9b.svg";